/** Shared wording of the CFO workflow's decisions, inputs and places. */

export const CFO_DECISIONS: Record<string, { label: string; className: string }> = {
  QUALIFIED: { label: "Qualified", className: "bg-emerald-50 text-emerald-700 ring-emerald-200" },
  NOT_QUALIFIED: { label: "Not qualified", className: "bg-slate-100 text-slate-700 ring-slate-200" },
  NEEDS_DATA: { label: "Missing data", className: "bg-amber-50 text-amber-800 ring-amber-200" },
  NEEDS_REVIEW: { label: "Needs review", className: "bg-sky-50 text-sky-800 ring-sky-200" },
};

/** The scoring inputs a decision can wait for (backend `result.missing`),
 *  and the answers the research stats count (`by_field`). */
export const CFO_INPUTS: Record<string, string> = {
  founder_geography: "Founder place",
  founder_place: "Founder place documented",
  founder_confirmed: "Founder confirmed",
  founder_added: "Founder added",
  place_country: "Country of a founder place",
  school_country: "Country of a founder's school",
  finance_team_level: "Finance team",
  has_hr_lead: "HR lead",
  has_cos_coo: "Chief of Staff or COO",
  hiring_finance_level: "Finance hiring",
  hiring_stratops: "Strategy & ops hiring",
  hiring_hr: "HR hiring",
  is_excluded_incubator: "Excluded incubator",
  is_tech_sector: "Tech sector",
  is_blacklisted_sector: "Excluded sector",
  identity: "Company identity",
  screening: "Exclusion list check",
  funding: "Reference round",
  funding_stage_group: "Funding stage",
};

export function inputLabel(key: string): string {
  return CFO_INPUTS[key] ?? key.replace(/_/g, " ");
}

let regionNames: Intl.DisplayNames | null = null;
/** "DE" becomes "Germany"; an unknown code stays as it is. */
export function countryName(code: string): string {
  try {
    regionNames ??= new Intl.DisplayNames(["en"], { type: "region" });
    const name = regionNames.of(code);
    return name && name !== code ? name : code;
  } catch {
    return code;
  }
}

/** "Berlin, Germany → DE" becomes "Berlin, Germany → Germany (DE)". */
export function withCountry(text: string): string {
  return text.replace(/→ ([A-Z]{2})$/, (_, code: string) => {
    const name = countryName(code);
    return name !== code ? `→ ${name} (${code})` : `→ ${code}`;
  });
}
